<template>
  <!-- 提交保存重复弹窗提示 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="60%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('book.list')"
      class-name="vertical-center-modal"
    >
      <div class="submit-table modalHeight">
        <h3 class="margin-bottom-20">{{ $t("book.repeatTip") }}</h3>
        <Table
          border
          :columns="submitErrorColumns"
          :data="dataList"
          stripe
          tooltip-theme="light"
        >
          <!-- 设备名称 -->
          <template slot="deviceName" slot-scope="{ row, index }">
            <span v-if="!dataList[index].isEdit">{{ row.deviceName }}</span>
            <Input v-else v-model="dataList[index].deviceName" maxlength="20" />
          </template>
          <!-- 设备ip -->
          <template slot="deviceIp" slot-scope="{ row, index }">
            <span v-if="!dataList[index].isEdit">{{ row.deviceIp }}</span>
            <Input v-else v-model="dataList[index].deviceIp" maxlength="20" />
          </template>
          <!-- 操作 -->
          <template slot="action" slot-scope="{ row, index }">
            <div v-if="!dataList[index].isEdit" class="actionLink">
              <Button type="primary" ghost @click="toEdit(row, index, 1)">
                {{ $t("common.modify") }}
              </Button>
              <Button type="error" ghost @click="delDevice(row, index)">
                {{ $t("common.delete") }}
              </Button>
            </div>
            <div v-else class="actionLink">
              <Button type="primary" ghost @click="updateDevice(row, index)">
                {{ $t("common.save") }}
              </Button>
              <Button type="error" ghost @click="toEdit(row, index, 0)">
                {{ $t("common.cancel") }}
              </Button>
            </div>
          </template>
        </Table>
        <div class="detailBackBtn">
          <Button size="large" @click="closeModal">{{
            $t("common.cancel")
          }}</Button>
          <Button v-debounce type="primary" size="large" @click="closeModal">{{
            $t("common.ensure")
          }}</Button>
        </div>
      </div>
    </Modal>
    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal
        ref="resultModal"
        :type="modalType"
        @afterComfirm="closeModal"
      ></modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "submitErrorModal",
  components: {},
  props: {
    currentNode: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      baseRow: {}, // 修改之前的保存对象
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "submitErrorColumns",
    ]),
  },
  watch: {
    dialogVisible: {
      handler() {},
    },
  },
  methods: {
    closeModal() {
      this.$emit("updateTree");
      this.dialogVisible = false;
    },
    toEdit(row, index, type) {
      this.baseRow = row;
      if (type === 1) {
        this.dataList[index].isEdit = true;
      } else {
        this.dataList[index].deviceName = this.dataList[index].baseName;
        this.dataList[index].deviceIp = this.dataList[index].baseIp;
        this.dataList[index].isEdit = false;
      }
    },
    // 删除设备
    delDevice(row, index) {
      this.setDeepArrDataDelete(
        this.areaDeviceData,
        row["treeNodeId"],
        "treeNodeId",
        "groupList",
        "name"
      );

      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );
      this.dataList.splice(index, 1);

      // 更新树组件的渲染
    },

    // 递归查找 tree 数据中的 id 的 名称; 可以传入 字段参数的名称 ，有默认值
    // 递归 遍历深层 数组 要有接收值 才可以
    setDeepArrDataDelete(
      arr,
      id,
      idStr = "treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (Number(item[idStr]) === Number(id)) {
          // 遍历
          arr.splice(i, 1);

          // 操作成功，关闭弹窗
          // this.$refs.resultModal.dialogVisible = true;
          // this.modalType = true;
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrDataDelete(item[child], id, idStr, child, name);
        }
      }
    },
    // 更新数据
    updateDevice(row, index) {
      // 校验输入值
      let ipReg = this.$store.state.common.ipReg;
      let nameReg = this.$store.state.common.nameReg;

      if (!ipReg.test(row.deviceIp)) {
        // 输入的不是ip
        this.$Message.error("ip" + this.$t("deviceSip.formatError"));
        return;
      } else {
        if (row.deviceIp === "127.0.0.1") {
          this.$Message.error(this.$t("deviceSip.forbidTip"));
          return;
        }
      }
      if (!nameReg.test(row.deviceName)) {
        this.$Message.error(this.$t("deviceSip.devnameTip2"));
        return;
      }

      this.setDeepArrDataUpdate(
        this.areaDeviceData,
        row["treeNodeId"],
        "treeNodeId",
        "groupList",
        "name",
        index
      );
      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );
      this.dataList[index].isEdit = false;
    },
    setDeepArrDataUpdate(
      arr,
      id,
      idStr = "treeNodeId",
      child = "groupList",
      name = "name",
      index
    ) {
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];

        if (Number(item[idStr]) === Number(id)) {
          // 编辑
          item.name = this.dataList[index].deviceName;
          item.netInfoDTO.ip = this.dataList[index].deviceIp;
          item = JSON.parse(JSON.stringify(item));
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrDataUpdate(item[child], id, idStr, child, name, index);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.submit-table {
  width: 90%;
  margin-left: 5%;
  margin-top: 30px;
  margin-bottom: 50px;
  height: 500px;
  overflow: auto;
}
</style>
